module.exports = __webpack_public_path__ + "static/media/monster-checkout-icon.13f39265.png";